import { defineStore } from 'pinia'

import { createOperatorReportingActions } from './actions'
import { createOperatorReportingState } from './state'

export const useOperatorReportingStore = defineStore('operatorReporting', () => {
    const state = createOperatorReportingState()
    const actions = createOperatorReportingActions(state)

    return {
        ...state,
        ...actions
    }
})
